// extracted by mini-css-extract-plugin
export default {"container":"Walls_container__wdTtF","productListContainer":"Walls_productListContainer__vNPuN","productGrid":"Walls_productGrid__ICVpo"};